import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <div className="navigation-links-left">
            <Link to="/">
              <div className="navigation-link">
                <span>Rooms</span>
              </div>
            </Link>
            <Link to="/">
              <div className="navigation-link">
                <span>Gallery</span>
              </div>
            </Link>
            <Link to="/">
              <div className="navigation-link">
                <span>Food &amp; Drink</span>
              </div>
            </Link>
          </div>
          <Link to="/">
            <div aria-label="LuxeVista Home" className="navigation-logo-link">
              <span className="navigation-logo-text section-title">
                LuxeVista
              </span>
            </div>
          </Link>
          <div className="navigation-links-right">
            <Link to="/">
              <div className="navigation-link">
                <span>Activities</span>
              </div>
            </Link>
            <Link to="/">
              <div className="navigation-link">
                <span>Reservation</span>
              </div>
            </Link>
            <Link to="/">
              <div className="navigation-link">
                <span>Contact</span>
              </div>
            </Link>
          </div>
          <button
            id="navigation-mobile-toggle"
            aria-expanded="false"
            aria-controls="navigation-mobile-overlay"
            aria-label="Toggle Navigation"
            className="navigation-toggle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="navigation-mobile-overlay" className="navigation-overlay">
        <div className="navigation-overlay-header">
          <span className="navigation-logo-text section-title">LuxeVista</span>
          <button
            id="navigation-mobile-close"
            aria-label="Close Navigation"
            className="navigation-close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Rooms</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Gallery</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Food &amp; Drink</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Activities</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Reservation</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Contact</span>
            </div>
          </Link>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-wrapper, .navigation-link, .navigation-overlay, .navigation-overlay-link {
  transition: none;
  animation: none;
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const toggleBtn = document.getElementById("navigation-mobile-toggle")
  const closeBtn = document.getElementById("navigation-mobile-close")
  const overlay = document.getElementById("navigation-mobile-overlay")
  const body = document.body

  const openMenu = () => {
    overlay.style.display = "flex"
    setTimeout(() => {
      overlay.classList.add("is-active")
      toggleBtn.setAttribute("aria-expanded", "true")
      body.style.overflow = "hidden"
    }, 10)
  }

  const closeMenu = () => {
    overlay.classList.remove("is-active")
    toggleBtn.setAttribute("aria-expanded", "false")
    body.style.overflow = ""
    setTimeout(() => {
      overlay.style.display = "none"
    }, 400)
  }

  toggleBtn.addEventListener("click", openMenu)
  closeBtn.addEventListener("click", closeMenu)

  // Close menu when clicking links
  const overlayLinks = overlay.querySelectorAll(".navigation-overlay-link")
  overlayLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  // Handle window resize to clean up state
  window.addEventListener("resize", () => {
    if (window.innerWidth > 767 && overlay.classList.contains("is-active")) {
      closeMenu()
    }
  })

  // Scroll effect for sticky header
  let lastScroll = 0
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset
    const nav = document.querySelector(".navigation-wrapper")

    if (currentScroll > 50) {
      nav.style.padding = "0"
      nav.style.boxShadow = "0 4px 20px rgba(0,0,0,0.05)"
    } else {
      nav.style.padding = "var(--spacing-xs) 0"
      nav.style.boxShadow = "none"
    }

    lastScroll = currentScroll
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
